var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "11px",
    viewBox: "0 0 16 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Arrow (Dropdown) Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.13172798,12.444228 L15.7562959,12.444228 C16.3088193,12.444228 16.756728,12.8934467 16.756728,13.4497635 L16.756728,14.3136925 C16.756728,14.8690344 16.3059144,15.319228 15.7562959,15.319228 L7.1261925,15.319228 L6.26226347,15.319228 C5.70692155,15.319228 5.25672798,14.8684144 5.25672798,14.3187959 L5.25672798,4.81966009 C5.25672798,4.2671367 5.70594673,3.81922798 6.26226347,3.81922798 L7.1261925,3.81922798 C7.68153441,3.81922798 8.13172798,4.27004161 8.13172798,4.81966009 L8.13172798,12.444228 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1.4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2-Profile-G",
    transform: "translate(-655.000000, -948.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrow-(Dropdown)-Copy",
    transform: "translate(652.000000, 941.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Dropdown-Arrow",
    fill: "#1D9F61",
    fillRule: "evenodd",
    transform: "translate(11.006728, 9.569228) rotate(-45.000000) translate(-11.006728, -9.569228) ",
    xlinkHref: "#path-1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.b39d02a6a847e461ef5035fc736bc0ed.svg";
export { ForwardRef as ReactComponent };